import BankTransferInstructions from './BankTransferInstructions';

export default BankTransferInstructions;
